export const GLOBAL_TIMEOUT = 20000;
const DEFAULT_TIMEOUT = GLOBAL_TIMEOUT;

export default (ms = DEFAULT_TIMEOUT) =>
  new Promise(resolve => setTimeout(resolve, ms));
